import { Paper } from "@mui/material";
import React from "react";
import CardHeaderTitle from "../../components/card-header-title/index.jsx";
import Topics from "../../components/topics/Topics";

const TopicSentimentChart = ({ topicdata }) => {
    return (
        <Paper
            sx={{ display: "flex", flexDirection: "column", width: '100%', borderRadius: 2.5, padding: 3, boxSizing: "border-box" }}
        >
            <CardHeaderTitle
                title="Topic Based Sentiment"
                tooltip="Topics are words or phrases that come up frequently across Conversations, and carry a Sentiment."
            />

            <Topics
                topicshits={topicdata}
                maxItems={15}
                sortKey="z"
                filterKey="keyword"
            />
        </Paper>
    );
};

export default TopicSentimentChart;
